export const searchActionType = {
  FLIGHT_LIST: "FLIGHT_LIST",
  SEARCH_DETAILS: "SEARCH_DETAILS",
  LOADER: "LOADER",
  PASSENGER_NUMBER: "PASSENGER_NUMBER",
};
